import { getAuth } from "@/client/lib/authHelpers";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(protected)")({
  beforeLoad: () => {
    const auth = getAuth();

    if (!auth?.token) {
      throw redirect({ to: "/" });
    }

    // if (auth.user.role !== "ADMIN") {
    //   throw redirect({ to: "/" });
    // }
  },
});
